import { createContext } from 'react';
import { User } from 'commons/types/user';

export interface UserContextData {
  user: User;
  setUser: React.Dispatch<React.SetStateAction<User>>;
}

export const UserContext = createContext<UserContextData | undefined>(undefined);
